// initial state
const state = {
  step: 0,
  subjectId: null,
  sections: null,
  excelOptions: null
}

// getters
const getters = {
  currentStep: state => {
    return state.step
  },
  getSubjectId: state => {
    return state.subjectId
  },
  getSections: state => {
    return state.sections
  },
  getExcelOptions: state => {
    return state.excelOptions
  }
}

// actions
const actions = {
  clearAll ({ commit }) {
    commit('clearAll')
  },
  clearSections ({ commit }) {
    commit('clearSections')
  },
  setSubjectIdandSections ({ commit }, data) {
    commit('setSubjectIdandSections', data)
  },
  nextStep ({ commit }, step) {
    commit('nextStep', step)
  },
  setExcelOptions ({ commit }, options) {
    commit('setExcelOptions', options)
  }
}

// mutations
const mutations = {
  clearAll (state) {
    state.step = 0
    state.subjectId = null
    state.sections = null
    state.excelOptions = null
  },
  clearSections (state) {
    state.sections = null
  },
  setSubjectIdandSections (state, data) {
    state.subjectId = data.subjectId
    state.sections = data.sections
  },
  nextStep (state, step) {
    state.step = step
  },
  setExcelOptions (state, options) {
    state.excelOptions = options
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
